var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AuthService from './AuthService';
import { environment } from '../config/environment';
import DebugService from './DebugService';
class LoggingService {
    constructor() {
        // Don't initialize values here - read them dynamically when needed
    }
    /**
     * Gets the logging API URL dynamically from environment config
     */
    getBaseUrl() {
        const url = environment.LOGGING_API_URL || '';
        if (!url) {
            DebugService.warn('[LoggingService] LOGGING_API_URL is empty, logging will be disabled');
        }
        return url;
    }
    /**
     * Gets the logging API key dynamically from environment config
     */
    getApiKey() {
        const key = environment.LOGGING_API_KEY || '';
        if (!key) {
            DebugService.warn('[LoggingService] LOGGING_API_KEY is empty');
        }
        return key;
    }
    static getInstance() {
        if (!LoggingService.instance) {
            LoggingService.instance = new LoggingService();
        }
        return LoggingService.instance;
    }
    getAuthHeaders() {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = {
                'Content-Type': 'application/json',
                'Ocp-Apim-Subscription-Key': this.getApiKey(),
            };
            try {
                // Get API token for authorization
                const apiTokenResult = yield AuthService.getApiToken();
                if (apiTokenResult === null || apiTokenResult === void 0 ? void 0 : apiTokenResult.accessToken) {
                    headers['Authorization'] = `Bearer ${apiTokenResult.accessToken}`;
                }
            }
            catch (error) {
                // If token acquisition fails, log without authorization
                // This ensures logging doesn't break the application
                DebugService.warn('Failed to get API token for logging');
            }
            return headers;
        });
    }
    postLog(logTable, body) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl();
            if (!baseUrl)
                return;
            try {
                const headers = yield this.getAuthHeaders();
                yield fetch(`${baseUrl}/${logTable}`, {
                    method: 'POST',
                    headers,
                    body: JSON.stringify(body),
                });
            }
            catch (err) {
                // Swallow errors to avoid breaking app flow
                // Log errors through DebugService
                DebugService.error('Error calling Logging Api');
            }
        });
    }
    logTrace(message_1) {
        return __awaiter(this, arguments, void 0, function* (message, severityLevel = 'Information', properties = {}) {
            yield this.postLog('trace', { severityLevel, message, properties });
        });
    }
    logEvent(trackingName_1) {
        return __awaiter(this, arguments, void 0, function* (trackingName, properties = {}, metrics = {}) {
            yield this.postLog('event', { trackingName, properties, metrics });
        });
    }
    logException(message_1) {
        return __awaiter(this, arguments, void 0, function* (message, properties = {}, metrics = {}) {
            yield this.postLog('exception', { message, properties, metrics });
        });
    }
    logPlacementRequest(placementId, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.logEvent('PlacementRequest', { placementId, userId });
        });
    }
    logError(error_1, context_1) {
        return __awaiter(this, arguments, void 0, function* (error, context, extra = {}) {
            yield this.logException(error.message, Object.assign({ context }, extra));
        });
    }
}
export default LoggingService.getInstance();
